import { jwtDecode } from 'jwt-decode'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { Column } from '@/components/core/Column'
import { useAuth } from '@/contexts/AuthContext.tsx'
import validateTestCode from '@/features/Login/services/validateTestCode.ts'
import { markDemoAccess } from '@/helpers/accessOrigin'
import { ROUTES } from '@/types/routes.ts'
import { Spinner } from '@/components/core'

export default function Demo() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { handleTestCodeValidated, resetTestData } = useAuth()

  const token = searchParams.get('token') ?? null

  useEffect(() => {
    if (token) {
      markDemoAccess()

      let data: { demo: boolean; code: string }
      try {
        data = jwtDecode(token)
      } catch (error) {
        console.log(error)
        resetTestData()
        navigate(ROUTES.ACCESS_EXPIRED, { replace: true })
        return
      }

      validateTestCode({
        code: data.code
      })
        .then((response) => {
          handleTestCodeValidated(data.code, response)

          setTimeout(() => {
            navigate(
              response.showOnboardingQuestions
                ? ROUTES.ONBOARDING.ONBOARDING_SURVEY
                : ROUTES.ONBOARDING.WELCOME,
              { replace: true }
            )
          }, 0)
        })
        .catch((error) => {
          console.log(error)
          resetTestData()
          navigate(ROUTES.ACCESS_EXPIRED, { replace: true })
        })
    }
  }, [token])

  return (
    <Column className="h-screen w-screen items-center justify-center">
      <Spinner className="text-white h-16 w-16" />
    </Column>
  )
}
